export const kycv2PersonStatusEnum = ['PENDING', 'IN_REVIEW', 'APPROVED', 'REJECTED', 'FLAGGED']

export const kycv2SessionStatusEnum = ['Not Started', 'In Progress', 'In Review', 'Approved', 'Declined']

export const kycv2PersonStatusColors = {
  PENDING: { bg: '#FF8A00', color: '#FBFFFC' },
  IN_REVIEW: { bg: '#4184c3', color: '#fafafa' },
  APPROVED: { bg: '#00B85F', color: '#FBFFFC' },
  REJECTED: { bg: '#dc3545', color: '#FFFFFF' },
  FLAGGED: { bg: '#9333ea', color: '#FFFFFF' },
}

export const kycv2SessionStatusColors = {
  'Not Started': { bg: '#FF8A00', color: '#FBFFFC' },
  'In Progress': { bg: '#4184c3', color: '#fafafa' },
  'In Review': { bg: '#4184c3', color: '#fafafa' },
  Approved: { bg: '#00B85F', color: '#FBFFFC' },
  Declined: { bg: '#dc3545', color: '#FFFFFF' },
}
